import { Injectable } from '@angular/core';

const angular = window['angular'];

@Injectable({
    providedIn: 'root',
})
export class EstensaServiceLocator {
    getService(serviceName: string) {
        const injector /*: angular.auto.IInjectorService*/ = angular.element(document.body).injector();

        return injector.get(serviceName);
    }
}
